import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { ScorecardSection as ScorecardSectionType } from '../types';
import ScorecardSection from './ScorecardSection';

interface DynamicSectionProps {
  section: ScorecardSectionType;
}

const DynamicSection: React.FC<DynamicSectionProps> = ({ section }) => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 4 }}>
      <Box
        sx={{
          backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[200],
          padding: '12px 16px',
          // borderRadius: 1,
          mb: 3,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            fontSize: '1.5rem',
            color: theme.palette.primary.main,
          }}
        >
          {section.title}
        </Typography>
      </Box>

      {section.subsections.map((subsection, index) => (
        <ScorecardSection key={index} title={subsection.title} subsection={subsection} />
      ))}
    </Box>
  );
};

export default DynamicSection;

